<template>
  <li
    class="p-team-user-profile-list__item p-team-user-profile-list__item--password"
    :class="{'is-active': isActive}"
  >
    <div class="p-team-user-profile__title">パスワード</div>
    <div class="p-team-user-profile__text">●●●●●●●●●●●●●●</div>
    <div class="p-team-user-profile__editor p-team-user-profile__editor--password">
      <div
        class="c-input"
        :class="{'is-error': valid.password != ''}"
      >
        <div class="c-input__title">現在のパスワード</div>
        <input
          v-model="inputPassword"
          class="c-input__item"
          type="password"
          name="password_old"
          value=""
          placeholder="現在のパスワードを入力してください"
          @blur="onChangePassword"
          @input="onChangePassword"
        />
        <div
          class="c-error c-error--balloon"
          :class="{'is-active': valid.password != ''}"
        >
          <div class="c-error__text">{{ valid.password }}</div>
        </div>
      </div>
      <div
        class="c-input"
        :class="{'is-error': valid.newPassword != ''}"
      >
        <div class="c-input__title">新しいパスワード</div>
        <input
          v-model="inputNewPassword"
          class="c-input__item"
          type="password"
          name="password_new"
          value=""
          placeholder="新しいパスワードを入力してください"
          @blur="onChangeNewPassword"
          @input="onChangeNewPassword"
        />
        <div
          class="c-error c-error--balloon"
          :class="{'is-active': valid.newPassword != ''}"
        >
          <div v-if="valid.newPassword != ''" class="c-error__text">{{ valid.newPassword }}</div>
        </div>
      </div>
      <div
        class="c-input"
        :class="{'is-error': valid.newPasswordConf != ''}"
      >
        <div class="c-input__title">新しいパスワード（確認）</div>
        <input
          v-model="inputNewPasswordConf"
          class="c-input__item"
          type="password"
          name="password_new_retype"
          value=""
          placeholder="確認のため、再度入力してください"
          @blur="onChangeNewPasswordConf"
          @input="onChangeNewPasswordConf"
        />
        <div
          class="c-error c-error--balloon"
          :class="{'is-active': valid.newPasswordConf != ''}"
        >
          <div v-if="valid.newPasswordConf != ''" class="c-error__text">{{ valid.newPasswordConf }}</div>
        </div>
        <ul class="p-team-user-profile-suppl-list">
          <li class="p-team-user-profile-suppl-list__item">
            パスワードは数字、英字大・小、記号(.+/-!?_#@)から2種類以上組み合わせて入力してください</li>
          <li class="p-team-user-profile-suppl-list__item">パスワードは6文字以上32文字以下で入力してください</li>
        </ul>
      </div>
    </div>
    <div class="p-team-user-profile__switch">
      <div class="c-text">
        <a @click="onTogglePasswordClick">変更する</a>
      </div>
    </div>
    <div class="p-team-user-profile__btns p-team-user-profile__btns--password">
      <a
        class="c-btn c-btn--gray u-w120 u-h30"
        @click="onCancelPasswordClick($event)"
      >
        <p class="c-btn__text">キャンセル</p>
      </a>
      <button
        :class="{'is-loading': isLoading}"
        class="c-btn c-btn--blue u-w120 u-h30"
        type="button"
        name="add_password"
        value="add-user"
        :disabled="isLoading || valid.password != '' || valid.newPassword != '' || valid.newPasswordConf != ''"
        @click="onChangePasswordClick($event)"
      >
        <p class="c-btn__text">保存する</p>
      </button>
    </div>

    <!-- モーダル: エラーメッセージ表示 -->
    <error-modal
      :is-active=isError
      :message=errorMessage
      :on-close-click="onCloseErrorModal"
    />
  </li>
</template>

<script>
import axios from 'axios';
export default {
  props: {},
  data () {
    return {
      errorMessage: '',
      isActive: false,
      isError: false,
      isLoading: false,
      inputPassword: null,
      inputNewPassword: null,
      inputNewPasswordConf: null,
      valid: {
        password: '',
        newPassword: '',
        newPasswordConf: '',
      }
    }
  },
  methods: {
    onTogglePasswordClick: function() {
      this.isActive = !this.isActive;
    },

    onCancelPasswordClick: function() {
      this.isActive = false;
    },

    onChangePassword:  function() {
      if (!this.inputPassword || this.inputPassword == '') {
        this.valid.password = '現在のパスワードを入力してください';
      } else {
        this.valid.password = '';
      }
    },

    onChangeNewPassword:  function() {
      if (!this.inputNewPassword || this.inputNewPassword == '') {
        this.valid.newPassword = '新しいパスワードを入力してください';
      } else {
        this.valid.newPassword = '';
      }
    },

    onChangeNewPasswordConf:  function(_event) {
      if (!this.inputNewPasswordConf || this.inputNewPasswordConf == '') {
        this.valid.newPasswordConf = '新しいパスワード（確認）を入力してください';
      } else {
        this.valid.newPasswordConf = '';
      }
    },


    onChangePasswordClick: function(event) {
      event.preventDefault();
      this.isLoading = true;

      // 入力バリデーション実行: 基本パターン
      this.onChangePassword();
      this.onChangeNewPassword();
      this.onChangeNewPasswordConf();

      // 入力バリデーション実行: 特殊パターン
      if(this.inputNewPassword != this.inputNewPasswordConf) {
        this.valid.newPassword = 'パスワードが一致していません';
        this.valid.newPasswordConf = 'パスワードが一致していません';
      }

      // 入力値検証結果に1つでも問題があった場合は処理終了
      if (this.valid.password != ''|| this.valid.newPassword != ''|| this.valid.newPasswordConf != '') {
        setTimeout(() => { this.isLoading = false; }, 300);
        return;
      }

      // ペイロードデータの作成
      const data = {
        password: this.inputPassword,
        newPassword: this.inputNewPassword,
      };

      axios.post('/api/team/update-password',data)
        .then(res => {
          if(this.handleResponse(res)){
            this.isActive = false;
          } else {
            this.isError = true;
            this.errorMessage = 'パスワードの更新に失敗しました'
          }

          setTimeout(() => { this.isLoading = false; }, 300);
        })
        .catch(error => {
          this.handleHttpError(error);
          this.isError = true;
          this.errorMessage = 'パスワードの更新に失敗しました'
          setTimeout(() => { this.isLoading = false; }, 300);
        });
    },

    // -----------------------------------------------------------------------------------------------------
    // エミット系メソッド一覧: 子孫のUI操作にフックエミットコールされるか、引き渡した関数オブジェクトからコールされるメソッド
    // -----------------------------------------------------------------------------------------------------
    // クリック: エラーモーダルを閉じる処理
    onCloseErrorModal: function() {
      this.isError = false
      this.errorMessage = ''
    },
  },
}
</script>
